<template>
  <div class="flex mt-1">
    <AdvantageIcon
      :name="iconName"
      :class="iconClasses"
      :circle="false"
      aria-hidden="true"
    />
    <div class="ml-4 mt-1">
      <dt class="font-alt font-semibold text-gray-900 leading-9 text-[30px]">{{ name }}</dt>
      <dd class="mt-1.5 text-gray-600">{{ description }}</dd>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { AdvantageIconNameType, AdvantageIconSizeType } from '@/types/advantage-types'
import { useAdvantageItemCasses } from '@/composables/useAdvantageItemCasses'

const props = defineProps({
  iconName: {
    type: String as PropType<AdvantageIconNameType> ,
    required: true,
  },
  name: {
    type: String as PropType<string>,
    required: true,
  },
  description: {
    type: String as PropType<string>,
    required: true,
  },
  iconSize: {
    type: String as PropType<AdvantageIconSizeType>,
    default: 'medium',
  }
})

const isSmall = computed<boolean>(() => ['small'].includes(props.iconSize))
const isMedium = computed<boolean>(() => ['medium'].includes(props.iconSize))
const isLarge = computed<boolean>(() => ['large'].includes(props.iconSize))

const { iconClasses } = useAdvantageItemCasses({ isSmall, isMedium, isLarge })
</script>
